import * as React from 'react';

import styles from './ai-summary.module.css';

type Props = {
    title: string;
};

export function HeaderAiSummary(props: Props) {
    return (
        <div className='flex align-center gap-8'>
            {props.title}
            <div className={styles['ai-summary-badge']}>AI</div>
        </div>
    );
}
